import type {FormErrorMessageProps} from '@chakra-ui/react';
import {FormErrorMessage} from '@chakra-ui/react';
import type {FieldPath, FieldValues} from 'react-hook-form';
import {useFormContext} from 'react-hook-form';

export type FieldErrorProps<TName> = {name: TName} & FormErrorMessageProps;

export const FieldError = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  ...rest
}: FieldErrorProps<TName>) => {
  const {getFieldState} = useFormContext<TFieldValues>();
  const {error} = getFieldState(name);

  return error?.message ? <FormErrorMessage {...rest}>{error?.message}</FormErrorMessage> : null;
};
